import { render, staticRenderFns } from "./EipBoDialog.vue?vue&type=template&id=8bb182b0&"
import script from "./EipBoDialog.vue?vue&type=script&lang=js&"
export * from "./EipBoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports